import { Zap, ZapOff } from "lucide-react";

import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

function tooltipFor({ isShowing, willRetarget, disabled }) {
  if (willRetarget) return "Show events for the current selection";
  if (isShowing) return "Hide events";
  if (disabled) return "Select machines to see their events";
  return "Show events";
}

/**
 * `willRetarget` is what the overlay showing a *different* set than the one
 * selected looks like: the control goes back to offering to show events, so the
 * stale overlay is visible as a state rather than something to guess at.
 */
export function ToggleEventsButton({
  isShowing = false,
  willRetarget = false,
  disabled,
  onToggle,
}) {
  const isDismiss = isShowing && !willRetarget;

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant={isDismiss ? "destructive" : "outline"}
            size="icon"
            disabled={disabled}
            onClick={onToggle}
          >
            {isDismiss ? (
              <ZapOff data-icon="inline-start" />
            ) : (
              <Zap data-icon="inline-start" />
            )}
          </Button>
        }
      />
      <TooltipContent>
        {tooltipFor({ isShowing, willRetarget, disabled })}
      </TooltipContent>
    </Tooltip>
  );
}
